import { render, staticRenderFns } from "./DownLinkData.vue?vue&type=template&id=80efea88&scoped=true&"
import script from "./DownLinkData.vue?vue&type=script&lang=js&"
export * from "./DownLinkData.vue?vue&type=script&lang=js&"
import style0 from "./DownLinkData.vue?vue&type=style&index=0&id=80efea88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80efea88",
  null
  
)

export default component.exports